module.exports = __webpack_public_path__ + "img/re3.97a2bbd9.jpg";